import $ from 'jquery';
import Vars from '../../vars';
import Action from "../classes/DropzoneAction";

import Facade from "../modules/Facade";
import Document from "../modules/Document";
import Request from "../../components/request";
import Modal from "../../components/Modal";
import Utils from "../../components/utils";

export default {
    _state : {
        items : {}
    },

    _args : {
        item     : {},
        parent   : {},
        entities : ''
    },

    _setArgs : function(args) {
        let self = this;

        self._args.item     = args.item ? args.item : self._args.item;
        self._args.parent   = args.parent ? args.parent : self._args.parent;
        self._args.entities = args.entities ? args.entities : self._args.entities;
    },

    _import : function(){
        let self = this;

        return {
            options  : {
                url                : '/api/objects/' + self._args.parent.id + '/' + self._args.entities + '/' + self._args.item.id + '/import?api_token=' + auth.user.api_token,
                addRemoveLinks     : true,
                paramName          : 'flats',
                thumbnailWidth     : 78,
                thumbnailHeight    : 78,
                maxFilesize        : 10,
                maxFiles           : 1,
                acceptedFiles      : '.xls,.xlsx',
                timeout            : 180000,

                dictDefaultMessage : 'Чтобы загрузить файл, выберите или просто перетащите их в это поле.<br />Файл должен иметь расширение .xls, .xlsx.<br />Нельзя загружать' +
                    ' больше' +
                    ' одного файла. Для повторного импорта очистите форму или обновите страницу.',
                maxfilesexceeded   : function(file) {
                    //this.removeAllFiles();
                    //this.addFile(file);
                },
                error: function (file, response) {
                    let $file = $(file._removeLink).parent();
                    $file.find('.dz-image').addClass('is-error');
                    $file.find('.dz-image img').remove();
                    $file.addClass('dz-file-preview');

                    $('.js-import').show();
                    if (response) {
                        $('.js-import-error').show();
                        let $ul = $('.js-import-error').children('ul');
                        $ul.empty();
                        let $li = $('<li/>').text(response);
                        $ul.append($li);
                    }
                }
            },
            complete : function(file, response, dropzone, item){
                let $file = $(file._removeLink).parent();
                if (file.name) {
                    $file.find('.dz-image').addClass('is-' + file.name.split('.').pop());
                    $file.find('.dz-image img').remove();
                    $file.addClass('dz-file-preview');
                }

                $('.js-import').show();
                if (response && response.errors && response.errors.length) {
                    $('.js-import-success').hide();
                    $('.js-import-error').show();
                    let $ul = $('.js-import-error').children('ul');
                    let message = '';
                    $ul.empty();
                    response.errors.forEach(function(error){
                        let $li = $('<li/>').text(error);
                        $ul.append($li);
                        message += '<p>' + error + '</p>';
                    });

                    new Modal({
                        title   : 'Ошибка импорта xsl файла',
                        content : Utils.renderProfileTemplate('info', {
                            message : message,
                            buttons : {
                                one : {
                                    class : 'confirm button--remove',
                                    title : 'Продолжить'
                                },
                                two : null
                            }
                        })
                    });
                }
                else if (response && response.result){
                    $('.js-import-success').show();
                    $('.js-import-error').hide();
                    let $ul = $('.js-import-success').children('ul');
                    $ul.empty();
                    if (response.name && response.name != '')
                        $ul.append(
                            $('<li />')
                                .text('Название файла: "' + response.name + '"')
                        );
                    if (response.datetime && response.datetime != '')
                        $ul.append(
                            $('<li />')
                                .text('Время и дата импорта файла: ' + response.datetime)
                        );
                    if (response.result.total || parseInt(response.result.total) == 0)
                        $ul.append(
                            $('<li />')
                                .text('Всего предложений: ' + response.result.total)
                        );
                    if (response.result.updated || parseInt(response.result.updated) == 0)
                        $ul.append(
                            $('<li />')
                                .text('Обработано предложений: ' + response.result.updated)
                        );
                    if (response.result.ignored || parseInt(response.result.ignored) == 0)
                        $ul.append(
                            $('<li />')
                                .text('Проигнорировано предложений: ' + response.result.ignored)
                        );

                    new Modal({
                        title   : 'Импорт прошёл успешно',
                        content : Utils.renderProfileTemplate('info', {
                            message : '',
                            buttons : {
                                one : {
                                    class : 'confirm button--edit',
                                    title : 'Продолжить'
                                },
                                two : null
                            }
                        })
                    });
                }
            }
        }
    },

    _facades : function() {
        let self = this;

        return {
            sortable : true,
            options  : {
                url                : '/api/objects/' + self._args.parent.id + '/' + self._args.entities + '/facades/create?api_token=' + auth.user.api_token,
                addRemoveLinks     : true,
                paramName          : 'facade',
                thumbnailWidth     : 78,
                thumbnailHeight    : 78,
                maxFilesize        : 10,
                maxFiles           : 20,
                acceptedFiles      : 'image/*',
                timeout            : 180000,

                dictDefaultMessage : 'Чтобы загрузить изображение, выберите или просто перетащите его в это поле',
                maxfilesexceeded   : function(file) {
                    //this.removeAllFiles();
                    //this.addFile(file);
                }
            },
            complete : function(file, response, dropzone, item){
                let $file = $(file._removeLink).parent();
                $file.addClass('dz-sortable');
                if (response && response.error) return;
                if (!file.facade) file.facade = response ? response.facade : null;
                if (!file.facade) return;

                $('<input />').attr('type', 'hidden').attr('name', 'building[facade_ids][]').val(file.facade.id).appendTo($file);

                $('<a />').addClass('dz-link').attr('href', file.facade.path_to_extra_large != '' ? file.facade.path_to_extra_large : file.facade.path_to_original).attr('target', '_blank').appendTo($file).click(function(e){
                    e.preventDefault();
                });

                new Facade({
                    mode     : Vars.facade.modes.building,
                    object   : self._args.parent,
                    building : self._args.item,
                    root     : $file,
                    item     : file.facade,
                    done     : function(response) {
                        file.facade = response.facade;
                        const countOfPolygons = file.facade ? file.facade.polygons.filter(function(polygon) {
                            return polygon.floor_id === undefined;
                        }).length : 0;

                        $file.find('.dz-information.count-of-polygons').html(countOfPolygons);
                        self._args.item.facades = self._args.item.facades.map(function(facade) {
                            if (facade.id != response.facade.id) return facade;
                            return response.facade;
                        });
                    },
                    update : function(){
                        return file.facade;
                    }
                });

                $('<div />').addClass('dz-information count-of-polygons').attr('title', 'Количество полигонов на изображении').appendTo($file).each(function() {
                    const countOfPolygons = file.facade.polygons.filter(function(polygon) {
                        return polygon.floor_id === undefined;
                    }).length;
                    $(this).html(countOfPolygons);
                }).click(function(e) {
                    e.preventDefault();
                    $file.find('.dz-link').trigger('click');
                });

                const actions = {
                    remove : {
                        isLink       : true,
                        confirmation : true,
                        args         : {
                            title        : 'Удаление изображения',
                            confirmation : 'это изображение'
                        }
                    },
                    rotate90 : {
                        isLink : true,
                        url    : function(file) {
                            return '/api/objects/' + self._args.parent.id + '/' + self._args.entities + '/facades/' + file.facade.id + '/rotate';
                        },
                        data   : {
                            angle: 270
                        }
                    },
                    rotate270 : {
                        isLink : true,
                        url    : function(file) {
                            return '/api/objects/' + self._args.parent.id + '/' + self._args.entities + '/facades/' + file.facade.id + '/rotate';
                        },
                        data   : {
                            angle: 90
                        }
                    }
                };

                new Action({
                    actions  : actions,
                    dropzone : dropzone,
                    file     : file,
                    entity   : 'facade',
                    done     : function (f) {
                        file.facade = f.facade;
                        $file.find('.dz-link').trigger('update');
                    }
                });

                $file.find('.dz-image').css('background-image', 'url(\'/' + (file.facade.path_to_small != '' ? file.facade.path_to_small : file.facade.path_to_original) + '\')');
                $file.find('.dz-image img').remove();
            },
            done: function(dropzone, item){
                item && item.facades && item.facades.sort(function(file1, file2){
                    return file1.sort - file2.sort;
                }).forEach(function(facade) {
                    let file = { name: '', size: 1 };
                    dropzone.emit('addedfile', file);
                    file.facade = facade;
                    dropzone.emit('processing', file);
                    dropzone.emit('complete', file);
                    dropzone.files.push(file);
                });
            }
        }
    },

    _images : function() {
        let self = this;

        return {
            sortable : true,
            options  : {
                url                : '/api/objects/' + self._args.parent.id + '/' + self._args.entities + '/images/create?api_token=' + auth.user.api_token,
                addRemoveLinks     : true,
                paramName          : 'image',
                thumbnailWidth     : 78,
                thumbnailHeight    : 78,
                maxFilesize        : 10,
                maxFiles           : 20,
                acceptedFiles      : 'image/*',
                timeout            : 180000,

                dictDefaultMessage : 'Чтобы загрузить изображение, выберите или просто перетащите его в это поле',
                maxfilesexceeded   : function(file) {
                    //this.removeAllFiles();
                    //this.addFile(file);
                }
            },
            complete : function(file, response, dropzone, item){
                var $file = $(file._removeLink).parent();
                $file.addClass('dz-sortable');
                if (response && response.error) return;
                if (!file.image) file.image = response ? response.image : null;
                if (!file.image) return;

                $('<input />').attr('type', 'hidden').attr('name', 'building[image_ids][]').val(file.image.id).appendTo($file);
                if(file.image.path_to_extra_large != ''){
                    $('<a />').attr('href', '/' + file.image.path_to_extra_large).attr('target', '_blank').addClass('dz-link').appendTo($file);
                }
                else {
                    $('<a />').attr('href', '/' + file.image.path_to_original).attr('target', '_blank').addClass('dz-link').appendTo($file);
                }

                const actions = {
                    remove : {
                        isLink       : true,
                        confirmation : true,
                        args         : {
                            title        : 'Удаление изображения',
                            confirmation : {
                                title : 'это изображение'
                            }
                        }
                    },
                    rotate90 : {
                        isLink : true,
                        url    : function(file) {
                            return '/api/objects/' + self._args.parent.id + '/' + self._args.entities + '/images/' + file.image.id + '/rotate';
                        },
                        data   : {
                            angle: 270
                        }
                    },
                    rotate270 : {
                        isLink : true,
                        url    : function(file) {
                            return '/api/objects/' + self._args.parent.id + '/' + self._args.entities + '/images/' + file.image.id + '/rotate';
                        },
                        data   : {
                            angle: 90
                        }
                    }
                };

                new Action({
                    actions  : actions,
                    dropzone : dropzone,
                    file     : file,
                    entity   : 'image'
                });

                $file.find('.dz-image').css('background-image', 'url(\'/' + (file.image.path_to_small != '' ? file.image.path_to_small : file.image.path_to_original) + '\')');
                $file.find('.dz-image img').remove();
            },
            done: function(dropzone, item){
                item && item.images && item.images.sort(function(file1, file2){
                    return file1.sort - file2.sort;
                }).forEach(function(image) {
                    let file = { name: '', size: 1 };
                    dropzone.emit('addedfile', file);
                    file.image = image;
                    dropzone.emit('processing', file);
                    dropzone.emit('complete', file);
                    dropzone.files.push(file);
                });
            }
        }
    },

    _typicalPlans : function() {
        let self = this;

        return {
            entity   : 'plan',
            sortable : true,
            options  : {
                url                : '/api/objects/' + self._args.parent.id + '/' + self._args.entities + '/plans/create?api_token=' + auth.user.api_token,
                addRemoveLinks     : true,
                paramName          : 'plan',
                thumbnailWidth     : 78,
                thumbnailHeight    : 78,
                maxFilesize        : 2,
                maxFiles           : 150,
                acceptedFiles      : 'image/*',
                timeout            : 180000,

                dictDefaultMessage : 'Чтобы загрузить изображение, выберите или просто перетащите его в это поле',
                maxfilesexceeded   : function(file) {
                    //this.removeAllFiles();
                    //this.addFile(file);
                }
            },
            complete : function(file, response, dropzone, item){
                let $file = $(file._removeLink).parent();
                if (response && response.error) return;
                if (!file.plan) {
                    file.plan = response ? response.plan : null;
                    file.parent_type = 'Building';
                }
                if (!file.plan) return;

                if (file.parent_type == 'Building') {
                    $('<input />').attr('type', 'hidden').attr('name', 'building[typical_plan_ids][]').val(file.plan.id).appendTo($file);
                    $file.addClass('dz-sortable');
                }

                $('<a />').addClass('dz-link').attr('href', '#').appendTo($file).click(function(e){
                    e.preventDefault();
                });

                $('<div />').addClass('dz-information count-of-attached-flats').attr('title', 'Количество квартир, закрепленных за данной типовой планировкой').appendTo($file).each(function() {
                    let countOfAttachedFlats = 0;
                    Object.keys(self._args.item).length && self._args.item.sections.forEach(function(section) {
                        section.flats.forEach(function(flat) {
                            if (flat.typical_plan_id == file.plan.id)
                                ++countOfAttachedFlats;
                        });
                    });
                    $(this).html(countOfAttachedFlats);
                });

                if (file.parent_type == 'Object') {
                    $(file._removeLink).remove();
                }
                else {
                    $file.addClass('dz-sortable');
                    const actions = {
                        remove : {
                            isLink       : true,
                            confirmation : true,
                            args         : {
                                title        : 'Удаление типовой планировки',
                                confirmation : {
                                    title : 'эту типовую планировку'
                                }
                            }
                        },
                        rotate90 : {
                            isLink : true,
                            url    : function(file) {
                                return '/api/objects/' + self._args.parent.id + '/' + self._args.entities + '/plans/' + file.plan.id + '/rotate';
                            },
                            data   : {
                                angle: 270
                            }
                        },
                        rotate270 : {
                            isLink : true,
                            url    : function(file) {
                                return '/api/objects/' + self._args.parent.id + '/' + self._args.entities + '/plans/' + file.plan.id + '/rotate';
                            },
                            data   : {
                                angle: 90
                            }
                        },
                        name     : {
                            isInput : true,
                            url     : function(file){
                                return '/api/objects/' + self._args.parent.id + '/' + self._args.entities + '/plans/' + file.plan.id + '/edit';
                            },
                            value : function(file){
                                return file.plan.name
                            },
                            data  : function(input){
                                return {
                                    plan: {
                                        name: input.val()
                                    }
                                }
                            },
                            done  : function(response){
                                if (response && response.plan) {
                                    file.plan.name = response.plan.name;
                                }
                            }
                        }
                    };

                    new Action({
                        actions  : actions,
                        dropzone : dropzone,
                        file     : file,
                        entity   : 'plan'
                    });
                }

                $file.find('.dz-image').css('background-image', 'url(\'/' + (file.plan.path_to_small != '' ? file.plan.path_to_small : file.plan.path_to_original) + '\')');
                $file.find('.dz-image img').remove();
            },
            done: function(dropzone, item){
                self._args.parent.typical_plans && self._args.parent.typical_plans.forEach(function(plan) {
                    let file = { name: '', size: 1 };
                    dropzone.emit('addedfile', file);
                    file.plan = plan;
                    file.parent_type = 'Object';
                    dropzone.emit('processing', file);
                    dropzone.emit('complete', file);
                    dropzone.files.push(file);
                });

                item.plans && item.plans.sort(function(image1, image2){
                    return image1.sort - image2.sort;
                }).forEach(function(plan) {
                    let file = { name: '', size: 1 };
                    dropzone.emit('addedfile', file);
                    file.plan = plan;
                    file.parent_type = 'Building';
                    dropzone.emit('processing', file);
                    dropzone.emit('complete', file);
                    dropzone.files.push(file);
                });
            }
        }
    },

    _document : function() {
        let self = this;

        return {
            sortable : true,
            options  : {
                url                : '/api/objects/' + self._args.parent.id + '/' + self._args.entities + '/documents/create?api_token=' + auth.user.api_token,
                addRemoveLinks     : true,
                paramName          : 'document',
                thumbnailWidth     : 78,
                thumbnailHeight    : 78,
                maxFilesize        : 10,
                maxFiles           : 50,
                timeout            : 180000,
                acceptedFiles      : '.doc,.docx,.pdf,.csv,.xls,.xlsx,.jpg,.jpeg,.png,.gif,.bmp',

                dictDefaultMessage : 'Чтобы загрузить документы, выберите или просто перетащите его в это поле',
                maxfilesexceeded   : function(file) {
                    //this.removeAllFiles();
                    //this.addFile(file);
                }
            },
            complete : function(file, response, dropzone, item){
                let $file = $(file._removeLink).parent();
                $file.addClass('dz-sortable');
                if (response && response.error) return;
                if (!file.document) file.document = response ? response.document : null;
                if (!file.document) return;

                $('<input />').attr('type', 'hidden').attr('name', 'building[document_ids][]').val(file.document.id).appendTo($file);
                let href = file.document.check == 1 ? ( (file.document.base) ? file.document.base : '' ) + file.document.path : '#';
                let $link = $('<a />').attr('href', href).attr('target', '_blank').addClass('dz-link').appendTo($file);
                if (file.document.check != 1) {
                    $link.attr('onClick', 'return false');
                }
                if (file.document.check == 0) {
                    $link.attr('title', 'Файл проверяется на наличие вирусов');
                } else if(file.document.check == 2) {
                    $link.attr('title', 'Мы подозреваем, что залитый файл является вирусной программой');
                }

                $('<a />').attr('href', '#').addClass('dz-edit').html('<i class="fa fa-pencil" />').appendTo($file).click(function(e) {
                    e.preventDefault();

                    new Document({
                        mode   : Vars.document.modes.building,
                        object : self._args.parent,
                        item   : file.document,
                        done   : function(response) {
                            file.document.type = response.document.type;
                            file.document.name = response.document.name;
                            $file.find('.dz-select').val(file.document.type || '');
                        }
                    });
                });

                const actions = {
                    remove : {
                        isLink       : true,
                        confirmation : true,
                        args         : {
                            title        : 'Удаление документа',
                            confirmation : {
                                title : 'это документ'
                            }
                        }
                    }
                };

                new Action({
                    actions  : actions,
                    dropzone : dropzone,
                    file     : file,
                    entity   : 'file'
                });

                $file.find('.dz-image').addClass('is-' + file.document.extension);
                $file.find('.dz-image img').remove();
                $file.addClass('dz-file-preview');

                if (file.document.check != 2) {
                    $('<select />').addClass('no-hidden').each(function () {
                        let $select = $(this);
                        $('<option />').prop('disabled', true).text('выберите тип').val('').appendTo($select);

                        Object.keys(ifacade.constants.documents.types).forEach(function (type) {
                            $('<option />').text(ifacade.constants.documents.types[type].name).val(type).appendTo($select);
                        });
                    }).addClass('dz-select').appendTo($file).each(function () {
                        $(this).val(file.document.type || '');
                    }).change(function () {
                        loader.increase();

                        Request.send({
                            path   : '/api/objects/' + self._args.parent.id + '/buildings/documents/' + file.document.id + '/edit',
                            method : 'POST',
                            data   : {
                                document: {
                                    type: $(this).val()
                                }
                            },
                            done: function (response) {
                                loader.decrease();
                                if (response && response.document) {
                                    file.document.type = response.document.type;
                                }
                            }
                        });
                    });
                }

                if(file.document.check == 0) {
                    $file.find('.dz-image').addClass('is-checking');
                }
                else if(file.document.check == 2) {
                    $file.find('.dz-image').addClass('is-virus');

                    let $virusList = $('#building-form .dropzone.is-document').next('.virus-list');
                    if (!$virusList.length) return;

                    $virusList = $('<ol/>').addClass('virus-list');
                    $('#building-form .dropzone.is-document').after($virusList);
                    $virusList
                        .append(
                            $('<li/>')
                                .text(file.document.name + '.' + file.document.extension)
                        );
                }
            },
            done: function(dropzone, item){
                item && item.documents && item.documents.sort(function(file1, file2){
                    return file1.sort - file2.sort;
                }).forEach(function(document) {
                    let file = { name: '', size: 1 };
                    dropzone.emit('addedfile', file);
                    file.document = document;
                    dropzone.emit('processing', file);
                    dropzone.emit('complete', file);
                    dropzone.files.push(file);
                });
            }
        }
    },

    get : function(args) {
        let self = this;

        self._setArgs(args);

        if (self._args.item) {
            self._state.items.import    = self._import();
        }
        self._state.items.facades       = self._facades();
        self._state.items.images        = self._images();
        self._state.items.typical_plans = self._typicalPlans();
        self._state.items.document      = self._document();

        return self._state.items;
    },
}